import { Component, OnInit, Inject } from '@angular/core';
import { ItemType, ItemCoverageTypes, ItemCoverageType } from '../../shared/models/item.type.interface';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { AdminService } from '../services/admin.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../models/generic.dialog.interface';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { EventService } from '../../shared/services/event.service';
import { EventType_Enum } from '../enums/event-type.enum';

@Component({
  selector: 'app-item-type',
  templateUrl: './item-type.component.html',
  styleUrls: ['./item-type.component.scss']
})
export class ItemTypeComponent extends AbstractBiditComponent implements OnInit {
  constructor(public adminService: AdminService, deviceDetectorService: DeviceDetectorService, private eventService: EventService,
    public dialogRef: MatDialogRef<ItemTypeComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) {
    super(deviceDetectorService);
  }

  private dealerSubscription: Subscription;
  itemType: ItemType;
  coverageTypes = ItemCoverageType;
  isIDIAdmin: boolean = false;
  dealerId: number;

  errors: string;
  isRequesting: boolean;
  ngOnInit() {
    this.isIDIAdmin = (AdminService._authNavStatusSource.value == 'IDI');
    this.dealerSubscription = AdminService.impersonatedDealer$.subscribe(dealerId => {
      if (this.isIDIAdmin) this.dealerId = dealerId;
    });

    let itemTypeId: string = this.data.id;

    if (itemTypeId == null) {
      this.itemType = {} as ItemType;
      this.itemType.itemType_IsActive = true;
    }
    else {
      this.adminService.getItemType(itemTypeId)
        .subscribe({
          next: (data) => {
            this.itemType = data;
          }
        });
    }
  }

  saveItemType(form: NgForm) {
    console.log('in item-type onSubmit: ', this.itemType);
    this.errors = '';
    if (form.valid) {
      this.isRequesting = true;

      let dealerId = this.adminService.getDealerId();
      this.itemType.dealer_ID = dealerId;

      this.adminService.saveItemType(this.itemType)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
            if (result) {
                // publish itemtypemodification event              
                this.eventService.publish(EventType_Enum.ItemTypeModification)              
                this.dialogRef.close();
            }
          },
          error: (error: string) => {
            this.errors = error;
          }
        });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
